/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ProductCategory,
    ProductCategoryFromJSON,
    ProductCategoryFromJSONTyped,
    ProductCategoryToJSON,
} from './';

/**
 * 
 * @export
 * @interface CreateProductCategoryResponse
 */
export interface CreateProductCategoryResponse {
    /**
     * 
     * @type {ProductCategory}
     * @memberof CreateProductCategoryResponse
     */
    product?: ProductCategory;
}

export function CreateProductCategoryResponseFromJSON(json: any): CreateProductCategoryResponse {
    return CreateProductCategoryResponseFromJSONTyped(json, false);
}

export function CreateProductCategoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateProductCategoryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'product': !exists(json, 'product') ? undefined : ProductCategoryFromJSON(json['product']),
    };
}

export function CreateProductCategoryResponseToJSON(value?: CreateProductCategoryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'product': ProductCategoryToJSON(value.product),
    };
}


